"use client"

import { buttonVariants } from "@/components/ui/button"
import { useEffect, useState } from "react"

export const DeviceDetailedSecx = ({ data }: { data: any }) => {
  const [viewMore, setViewMore] = useState(false)
  const [viewFeat, setViewFeat] = useState(data?.deviceFeatures?.length ?? 0)

  const mockFeatures = data?.deviceFeatures

  const deviceFeatures =
    data?.deviceFeatures && data?.deviceFeatures?.length !== 0
      ? data?.deviceFeatures
      : mockFeatures

  useEffect(() => {
    setViewFeat(deviceFeatures?.length > 4 ? 4 : deviceFeatures?.length)
  }, [data])

  const handleViewMore = () => {
    setViewMore(!viewMore)
    setViewFeat(viewMore ? 4 : deviceFeatures?.length ?? 0)
  }
  const [selectedSection, setSelectedSection] = useState("Product Description")

  const sections = [
    "Product Description",
    "Technical Specs",
    "Additional Details",
  ]
  return (
    <section className="flex lg:px-32 flex-col sm:py-24">
      <h1 className="sm:text-4xl text-xl font-orange text-center pb-4">
        Specification
      </h1>
      {/* <div className="flex items-center justify-between sm:pt-8 sm:pb-4 gap-8 lg:gap-0 overflow-x-auto lg:overflow-hidden lg:mx-20  xl:mx-40">
        {sections?.map((section) => (
          <h1
            key={section}
            className={`  gap-3 group flex text-nowrap justify-center font-gilroySemiBold w-fit items-center text-base rounded py-2 px-4 cursor-pointer transition-all ${
              selectedSection === section
                ? "bg-black hover:bg-black text-white"
                : " bg-white hover:bg-gray-100 text-black"
            }`}
            onClick={() => setSelectedSection(section)}
          >
            {section}{" "}
            {selectedSection === section ? (
              <ChevronUp className="size-4  " />
            ) : (
              <ChevronDown className="size-4 group-hover:mt-1 duration-300" />
            )}
          </h1>
        ))}
      </div> */}

      {/* <div className="bg-gray-200 hidden lg:flex  h-[1px] sm:mx-0 lg:mx-10 xl:mx-20"></div> */}
      <h1 className="sm:text-2xl text-xl font-orange text-center py-8">
        Details
      </h1>

      <p className="text-pretty py-3.5 px-8  font-gilroySemiBold  text-sm sm:text-base">
        {data?.description}
      </p>
      {deviceFeatures?.slice(0, viewFeat)?.map((feat) => (
        <div key={feat?.title}>
          <h3 className="text-xl 2xl:text-2xl text-center font-orange pt-4 pb-3 ">
            {feat?.title}
          </h3>
          {feat?.features?.map((v) => (
            <div key={v?.title} className="pt-1 pb-3 px-8">
              <div className="flex items-center font-gilroyMedium justify-between w-full">
                <span>{v?.title}</span>
                <span className="text-sm max-sm:w-1/2 flex items-center justify-end">
                  {v?.value}
                </span>
              </div>
              <div className="h-[1px] sm:my-2 my-1 w-full bg-[#CDCDCD]" />
            </div>
          ))}
        </div>
      ))}
      {deviceFeatures?.length > 4 && (
        <div className="flex items-center justify-center py-4">
          <button onClick={handleViewMore}>
            {viewMore ? (
              <>
                <span
                  className={buttonVariants({
                    variant: "default",
                    className:
                      "w-fit cursor-pointer font-gilroySemiBold hover:bg-white hover:text-black border border-black px-9 lg:px-16 my-2",
                  })}
                >
                  View Less
                </span>
              </>
            ) : (
              <>
                <span
                  className={buttonVariants({
                    variant: "default",
                    className:
                      "w-fit cursor-pointer font-gilroySemiBold hover:bg-white hover:text-black border border-black px-9 lg:px-16 my-2",
                  })}
                >
                  View More
                </span>
              </>
            )}
          </button>
        </div>
      )}
    </section>
  )
}
